import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPencil01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.707 2.293a3.829 3.829 0 0 0-5.414 0L4.976 13.609c-.233.234-.41.41-.565.61a4 4 0 0 0-.364.56c-.12.223-.209.456-.327.764l-2.153 5.598a1 1 0 0 0 1.292 1.292l5.38-2.069.093-.036.125-.048c.308-.118.541-.208.764-.327.196-.106.384-.228.56-.364.2-.155.376-.332.61-.566L21.707 7.707a3.828 3.828 0 0 0 0-5.414ZM5.381 16.795l-1.14 2.964 2.964-1.14-1.824-1.824Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgPencil01.displayName = 'Pencil01';
export default SvgPencil01;
